<div class="date-container">
  <ion-datetime
    presentation="date"
    doneText="Update"
    cancelText="Cancel"
    [yearValues]="years"
    (ionChange)="updateDate($event)"
    [showDefaultButtons]="true"
    [(ngModel)]="selectedDate"
  ></ion-datetime>
</div>
